import React from 'react';
import { Button, Dropdown } from 'antd';
import { ArrowDownWideNarrow, ArrowUpWideNarrow } from 'lucide-react';
import styles from '../index.module.css';
import cx from 'classnames';

export enum SortBy {
  UPDATED_AT = 'updated_at',
  CREATED_AT = 'created_at'
}

export enum SortDirection {
  ASC = 'asc',
  DESC = 'desc'
}

type Props = {
  sortBy: SortBy;
  setSortBy: (sortBy: SortBy) => void;
  sortDirection: SortDirection;
  setSortDirection: (sortDirection: SortDirection) => void;
  container: HTMLDivElement;
};

export const SitesSortBy = ({
  sortBy,
  setSortBy,
  sortDirection,
  setSortDirection,
  container
}: Props) => {
  const sortIcon =
    sortDirection === SortDirection.DESC ? (
      <ArrowDownWideNarrow className={styles.sortDirectionIcon} />
    ) : (
      <ArrowUpWideNarrow className={styles.sortDirectionIcon} />
    );

  const byUpdated = sortBy === SortBy.UPDATED_AT;
  const byCreated = sortBy === SortBy.CREATED_AT;
  const nextDirection =
    sortDirection === SortDirection.DESC
      ? SortDirection.ASC
      : SortDirection.DESC;

  return (
    <Dropdown
      className={styles.dropdown}
      placement="bottomLeft"
      menu={{
        items: [
          {
            key: SortBy.UPDATED_AT,
            label: (
              <span
                className={cx(styles.sortLabel, { [styles.active]: byUpdated })}
              >
                Updated at
                {byUpdated && sortIcon}
              </span>
            ),
            onClick: () => {
              if (byUpdated) setSortDirection(nextDirection);
              else setSortBy(SortBy.UPDATED_AT);
            }
          },
          {
            key: SortBy.CREATED_AT,
            label: (
              <span
                className={cx(styles.sortLabel, { [styles.active]: byCreated })}
              >
                Created at
                {byCreated && sortIcon}
              </span>
            ),
            onClick: () => {
              if (byCreated) setSortDirection(nextDirection);
              else setSortBy(SortBy.CREATED_AT);
            }
          }
        ],
        onClick: e => console.log(e)
      }}
      getPopupContainer={() => container}
      trigger={['click']}
    >
      <Button
        type="text"
        title="Sort project sites"
        style={{ borderColor: 'transparent' }}
        icon={<ArrowDownWideNarrow className={styles.filterIcon} />}
        className={styles.sitesSortButton}
      />
    </Dropdown>
  );
};
